import AdminLogin from "../components/AdminLogin";
import useLogin from "../hooks/useLogin";

const AdminLoginPage = () => {
    const useAdminLoginProps = useLogin();
    return (
        <AdminLogin {...useAdminLoginProps} />
    )
}

export default AdminLoginPage;